/** 個人頻道的抽獎狀態喚醒事件，跨 entry 以 DOM CustomEvent 橋接 */
export const DRAW_STATUS_EVENT = 'wtoy:draw-status-changed';

/**
 * 從 Ably message.data（或 CustomEvent.detail）取出 order id。
 * payload 來自網路，型別不保證，取不到就回 null 讓呼叫端忽略。
 * @param {*} data
 * @returns {?number}
 */
export function drawStatusOrderId(data) {
    if (data === null || typeof data !== 'object') {
        return null;
    }

    const raw = data.order_id;
    if (raw === undefined) {
        return null;
    }

    const orderId = Number(raw);
    if (!Number.isInteger(orderId) || orderId <= 0) {
        return null;
    }

    return orderId;
}
